import { fetchAddressByCep } from '@/services/cep.service';
import { fetchState } from '@/services/cep.service';
import { fetchCitysByState } from '@/services/cep.service';

export const address = {
    namespaced: true,
    actions: {
        lookupCep({ }, cep) {
            return fetchAddressByCep(cep)
                .then((result) => {
                    return Promise.resolve(result);
                })
                .catch((e) => {
                    return Promise.reject(e);
                });
        },

        lookupCity({ }, state) {
            return fetchCitysByState(state)
                .then((result) => {
                    return Promise.resolve(result);
                })
                .catch((e) => {
                    return Promise.reject(e);
                });
        },

        lookupState({ } ) {
            return fetchState()
                .then((result) => {
                    return Promise.resolve(result);
                })
                .catch((e) => {
                    return Promise.reject(e);
                });
        },
    }
};